"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
function toUtcFormat(dateTime) {
    return (0, moment_1.default)(dateTime).utc().toISOString();
}
exports.default = toUtcFormat;
//# sourceMappingURL=toUtcFormat.js.map